/**
 *  hide
 **/
(function () {
  "use strict";
  function attachHideEvent(el) {
    const main = el.querySelectorAll(".hide-content");
    let title = el.title;
    if (el.body) {
      title += el.body.className;
    } else {
      const htmlText = el.textContent.replace(/\s+/g, "");
      title = document.createTextNode(htmlText);
    }

    (async () => {
      // ID 作成処理
      let unique_id = await sha256(title);
      main.forEach((element, key) => {
        let id = "hide-" + unique_id + "-" + key;
        let btn_id = "hide-" + unique_id + "-" + key + "-btn";
        let target_id = "#hide-" + unique_id + "-" + key;
        let content_id = "hide-" + unique_id + "-" + key + "-icon";

        // element
        let anchor = element.querySelector("a.btn-hide");
        let anchor_i = anchor.querySelector("i");
        let this_collapse = element.querySelector(".hide-collapse");

        if (this_collapse) {
          this_collapse.id = id;
        }
        if (anchor) {
          anchor.id = btn_id;
          anchor.setAttribute("data-target", target_id);
        }
        if (anchor_i) {
          anchor_i.id = content_id;
        }
      });

      // hideの開閉状態を記憶
      let hide_content = el.querySelectorAll(".hide-content .collapse");
      let hide_collapse = el.querySelectorAll(".hide-collapse");

      hide_content.forEach((element) => {
        // Bootstrapがjqeuryのため開閉イベント取得はjqeury
        $(element).on("show.bs.collapse", function () {
          var max_size = 20;
          var active = this.id;
          var panels =
            localStorage.panels === undefined
              ? []
              : JSON.parse(localStorage.panels);
          if (!panels.includes(active)) {
            panels.push(active);
            if (panels.length > max_size) {
              panels = panels.slice(panels.length - max_size);
            }
          }
          localStorage.panels = JSON.stringify(panels);
        });
      });

      hide_collapse.forEach((element) => {
        // Bootstrapがjqeuryのため開閉イベント取得はjqeury
        $(element).on("hide.bs.collapse", function () {
          var active = this.id;
          var panels =
            localStorage.panels === undefined
              ? []
              : JSON.parse(localStorage.panels);
          var elementIndex = panels.indexOf(active);
          if (elementIndex !== -1) {
            panels.splice(elementIndex, 1);
          }
          localStorage.panels = JSON.stringify(panels);
        });
      });

      try {
        var panels =
          localStorage.panels === undefined
            ? []
            : JSON.parse(localStorage.panels);

        for (var i in panels) {
          let panel = el.querySelector("#" + panels[i]);
          if (panel && panel.classList.contains("hide-collapse")) {
            let btn = el.querySelector("#" + panels[i] + "-btn");
            if (!panel.classList.contains("in")) {
              //開く
              $(panel).collapse("show");
              //開くボタンの見た目を変える
              btn.classList.remove("collapsed");
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }

  document.addEventListener("DOMContentLoaded", function () {
    attachHideEvent(document);
  });

  document.addEventListener("customDOMContentLoaded", function (event) {
    const modalWindow = event.detail.modalWindow;
    attachHideEvent(modalWindow);
  });

  async function sha256(str) {
    const buff = new Uint8Array([].map.call(str, (c) => c.charCodeAt(0)))
      .buffer;
    const digest = await crypto.subtle.digest("SHA-256", buff);
    return [].map
      .call(new Uint8Array(digest), (x) => ("00" + x.toString(16)).slice(-2))
      .join("");
  }
})();
